import { TIMEFRAMES_RECEIVED } from '../action-list';

export default function(state = [], action) {
  switch (action.type) {
    case TIMEFRAMES_RECEIVED:
      return action.payload;

    default:
      return state;
  }
}
